var React = require('react');

function Selected (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 2L12 21L0 2H24Z","fill":"currentColor"}));
}

Selected.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Selected;

Selected.default = Selected;
